module.exports = __webpack_public_path__ + "img/avatar3.5f5dc1d2.png";